/**
 * Регистрация CRM-расширений Activity.
 *
 * Единая точка подключения CRM к ядру Activity: дескрипторы сущностей
 * (партнёр/лид/сделка), действия шапки чата и slash-команды. Вызывается из
 * client bootstrap модуля CRM.
 */
import {
  registerActivityContactSearchProvider,
  registerActivityEntity,
  registerActivityHeaderAction,
  registerActivityScopeMentionProvider,
} from '@ayocore/activity/client/extensions';
import {
  dealActivityEntity,
  leadActivityEntity,
  partnerActivityEntity,
} from './crm-activity-entities';
import {
  crmNewDealHeaderAction,
  crmNewTaskHeaderAction,
} from './crm-activity-header-actions';
import {
  crmContactSearchProvider,
  crmDealScopeMentionProvider,
} from './crm-activity-mentions';
// Side-effect регистрация slash-команд чата (реестр живёт в @ayocore/activity).
import './commands';

/** Регистрирует все CRM-расширения Activity. Идемпотентно (upsert по ключам). */
export function registerCrmActivityExtensions(): void {
  registerActivityEntity(partnerActivityEntity);
  registerActivityEntity(leadActivityEntity);
  registerActivityEntity(dealActivityEntity);

  registerActivityHeaderAction(crmNewTaskHeaderAction);
  registerActivityHeaderAction(crmNewDealHeaderAction);

  registerActivityScopeMentionProvider(crmDealScopeMentionProvider);
  registerActivityContactSearchProvider(crmContactSearchProvider);
}
